import css from 'styled-jsx/css'

export const ResetStyle = css.global`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 22px;
    color: var(--black);
    background-color: var(--neutral);
  }
  html {
    font-size: 62.5%;
  }
  input,
  label,
  button,
  select,
  textarea {
    font-family: 'Roboto', sans-serif;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }
  p {
    margin-top: 0;
    margin-bottom: 1em;
  }
  a {
    color: var(--primary);
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
    -webkit-text-decoration-skip: objects;
  }
  a:hover {
    color: #5a3cda;
  }
  a:active {
    color: #4527c4;
  }
  a:active,
  a:hover {
    text-decoration: none;
    outline: 0;
  }
  a:focus {
    text-decoration: none;
    outline: 0;
  }
  a[disabled] {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    pointer-events: none;
  }
  a.link-text {
    color: #262626;
  }
`
